import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import EditAccount from "../Accounting/EditAccount";
import EditCustomer from "../EditCustomer";
import EditSale from "../EditSale";
import EditSupplier from "../EditSupplier";
import MainMenu from "../MainMenu";
import Notifications from "../Notifications";
import Search from "../Search";

const App = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div
      className={props.className}
      onContextMenu={(event) => {
        event.preventDefault();
      }}
    >
      <AppBar elevation={0} position="static">
        <Toolbar className="Toolbar">
          <IconButton onClick={toggleMenu}>
            <MenuIcon />
          </IconButton>
          <Breadcrumbs
            aria-label="breadcrumb"
            className="Breadcrumbs"
            sx={{ flexGrow: 1 }}
          >
            {props.breadcrumbs}
          </Breadcrumbs>
        </Toolbar>
        {props.searchable && <Search />}
      </AppBar>
      <MainMenu open={isMenuOpen} onClose={closeMenu} />
      <Outlet />
      <EditAccount />
      <EditCustomer />
      <EditSale />
      <EditSupplier />
      <Notifications />
    </div>
  );
};

export default styled(App)(
  ({ theme }) => `
  .Breadcrumbs {
    font-family: milliard-light;
  }

  .Toolbar {
    padding: 0 16px;
    min-height: 56px;
  }
`,
);
